import { ContentNugget, NUGGET_VARIANTS, NuggetCardActionProps } from '@backrs_ui/common-ui';

import { useMyCollegeToggle } from '@backrs_ui/grow-ui/src/components/MyColleges/useMyCollegeToggle';
import { handleBookmark } from '@backrs_ui/grow-ui/src/components/Nuggets/nugget.util';
import { getShareUrl } from '@backrs_ui/grow-ui/src/components/Nuggets/nuggetLinks';
import { getBookmarkIdForNugget } from '@backrs_ui/grow-ui/src/pages/Bookmarks/pages/bookmarks.util';
import {
  useDeleteBookmarkMutation,
  useGetBookmarksQuery,
  usePostBookmarkMutation,
} from '@backrs_ui/grow-ui/src/redux/bookmarks/bookmarks.api';
import { useAppSelector } from '@backrs_ui/grow-ui/src/redux/hooks';
import { selectIsSharedSessionActive } from '@backrs_ui/grow-ui/src/redux/sharedSession/sharedSession';

export const useNuggetCardActions = (nugget: ContentNugget): NuggetCardActionProps | undefined => {
  const isSharedSession = useAppSelector(selectIsSharedSessionActive);
  const { data: bookmarks } = useGetBookmarksQuery(undefined);
  const bookmarkId = getBookmarkIdForNugget(bookmarks, nugget.id, nugget.variant);
  const [postBookmark] = usePostBookmarkMutation();
  const [deleteBookmark] = useDeleteBookmarkMutation();
  const myCollege = useMyCollegeToggle(
    nugget.variant === NUGGET_VARIANTS.INSTITUTION ? nugget.college_info : null,
  );

  if (isSharedSession) return undefined;

  return {
    ...(myCollege.isAvailable && {
      isInMyColleges: myCollege.isInMyColleges,
      onToggleMyColleges: myCollege.toggle,
    }),
    hasBookmarked: !!bookmarkId,
    onBookmark: async () => {
      try {
        await handleBookmark({
          bookmarkId,
          nuggetId: nugget.id,
          variant: nugget.variant,
          postBookmark,
          deleteBookmark,
        });
      } catch (error) {
        console.error('Failed to update bookmark:', error);
        throw error;
      }
    },
    onShare: async () => {
      const shareUrl = getShareUrl({ contentNugget: nugget });

      try {
        await navigator.clipboard.writeText(shareUrl);
      } catch (error) {
        console.error('Failed to copy link to clipboard:', error);
        throw error;
      }
    },
  };
};
